import React from 'react';
import { Field } from 'react-form';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import InfoButton from '../../InfoButton';
// eslint-disable-next-line
import styles from './slider.scss';
import { ratingTypes } from '../../../utils/constants';

const UTRRangeSliderSmall = props => (
    <Field field={props.field} validate={props.validate}>
        { fieldApi => {
            const { onChange, onBlur, field, validate, max, label, hoverText, 'data-testid': dataTestId, ...rest } = props;
            const { value, setValue, setTouched } = fieldApi;

            const inputProps = {
                ...rest,
                value: value || [],
                change: e => {
                    setValue(e.target.value);
                    if (onChange) {
                        onChange(e.target.value, e);
                    }
                },
                onBlur: e => {
                    setTouched();
                    if (onBlur) {
                        onBlur(e);
                    }
                },
            };

            return (
                <div className="form-group form-group-xl help slider-small" data-testid={dataTestId || undefined}>
                    <label className="mb10" htmlFor="name">
                        {`${label || ratingTypes.tennis}`}
                        {hoverText && <InfoButton hoverText={hoverText} />}
                        <span className="utr text-dark" data-testid={dataTestId && `${dataTestId}.value`}>{`${value[0]?.toFixed(1)} - ${value[1]?.toFixed(1)}`}{value[1]?.toFixed(1) === 16.0 ? '+' : ''}</span>
                    </label>
                    <div className="wrapper" data-testid={dataTestId && `${dataTestId}.slider`}>
                        <ReactBootstrapSlider
                            {...inputProps}
                            startValue={[1, 16]}
                            range={true}
                            max={max || 16}
                            min={1}
                            step={0.5}
                        />
                    </div>
                </div>
            );
        }}
    </Field>
);

export default UTRRangeSliderSmall;
